import { useEffect } from "react"

import dayjs from "src/dayjs"

const useClassPeriodRefresh = (
  endsAt: string | undefined,
  nextStartsAt: string | undefined,
  refetch: (opts: object) => void
) => {
  // refresh on current period end time or next period start time, whichever comes first
  const deadline = [endsAt, nextStartsAt]
    .filter((timestamp): timestamp is string => Boolean(timestamp))
    .sort((timestamp, otherTimestamp) =>
      dayjs(timestamp).diff(dayjs(otherTimestamp))
    )[0]

  useEffect(() => {
    if (!deadline) return

    const msUntilDeadline = dayjs(deadline).diff(dayjs())

    const timeout = setTimeout(
      () => refetch({ requestPolicy: "network-only" }),
      Math.max(msUntilDeadline, 0) + 1000
    )
    return () => clearTimeout(timeout)
  }, [deadline, refetch])
}

export default useClassPeriodRefresh
